<template>
  <div>

    <!--title start-->
    <div id="printtitle">
      <!-- menu title -->
      <div class="grab">
        <div class="tit_nav">
          <h4>{{ $t("centerci") }}</h4>
        </div>
      </div>
    </div>

    <!--content start-->
    <div id="ci" class="h4wrap grab">
      <div class="border_dashed_b mt_30">
        <h5 class="h5_title">{{ $t("symbol") }}</h5>
        <div class="ci_section01">
          <img class="ci_image" src="/static/img/ci_image01.jpg">
          <div class="ci_content">
            <p>{{ $t("symbol_detail") }}</p>
            <button class="location_btn" onclick="window.open('./static/rcae_logo.zip')" tark>
              <span class="glyphicon glyphicon-download-alt"></span>{{ $t("cidownload") }}</button>
          </div>
        </div>
      </div>
      <div class="border_dashed_b mt_30">
        <h5 class="h5_title">{{ $t("signature") }}</h5>
        <div class="ci_section02">
          <img class="ci_image" src="/static/img/ci_image02.jpg">
          <img style="margin-top: 20px" class="ci_image" src="/static/img/ci_image03.jpg">
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'CenterCI'
  }
</script>



// WEBPACK FOOTER //
// src/components/CenterCI.vue